export const bim = {
  addBim: "添加BIM",
  progressHelp: "文件必须处理后才能查看，此过程可能需要几分钟。",
  errorUpload: "上传文件时出错，请联系支持。",
  pendingUpload: "文件正在上传，这可能需要几分钟，请稍后再回来。",
  successUpload: "文件已成功上传。",
  deleteBim: "删除BIM",
  deleteBimConfirmation: "您确定要删除BIM吗？",
};
